<template>
  <form @submit.prevent="save(v)" class="one d-block mb-3 animation-sortable-item" :class="{'one-done': v.is_done}">
    <transition name="animation-slide">
    <div v-if="!isSelected(v)">
      <div class="form-check form-switch form-switch-lg">
        <input @click.stop="v._is_done = !v._is_done; select(v);" v-model="v._is_done" type="checkbox" role="switch" :id="`flexSwitchCheckDefaultClose_${v.id}`" class="form-check-input">
        <div @click.stop="select(v);" class="form-check-label ms-3 me-4 mt-2"><span class="one-id">{{ v.id }}</span>{{ v.task }}</div>
        <!--label @click.stop="select(v);" class="one-toggle-info-button" :for="`flexSwitchCheckDefaultClose_${v.id}`"><i class="bi bi-arrow-down-circle-fill"></i></label-->
        <div class="one-deadline hide-while-run-animation" v-if="+v.deadline_time_only">
          <span :class="getDeadlineColor(v.deadline_time_only)">До: {{ v.deadline_inFormat }}</span>
        </div>
        <i v-if="v.synchronizating" class="one-important-status spinner-border spinner-border-sm"><span class="visually-hidden">Синхронизация...</span></i>
      </div>
      <div v-if="!v.is_done">
        <div v-if="!!v.description" class="one-desc text-secondary">
          {{ v.description }}
        </div>
      </div>
    </div>
    <div v-else>
      <div class="form-check form-switch form-switch-lg">
        <input v-model="v._is_done" type="checkbox" role="switch" :id="`flexSwitchCheckDefaultOpen_${v.id}`" class="form-check-input">
        <div @click.stop="deselect(v);" class="form-check-label ms-3 me-4 mt-2"><span class="one-id">{{ v.id }}</span>{{ v.task }}</div>
        <!--label @click.stop="deselect(v);" class="one-toggle-info-button" :for="`flexSwitchCheckDefaultOpen_${v.id}`"><i class="bi bi-arrow-up-circle-fill"></i></label-->
        <div class="one-deadline hide-while-run-animation" v-if="+v.deadline_time_only">
          <span :class="getDeadlineColor(v.deadline_time_only)">До: {{ v.deadline_inFormat }}</span>
        </div>
      </div>
      <div v-if="!!v.description" class="one-desc text-secondary">
        {{ v.description }}
      </div>
      <div class="mt-3">
        <textarea class="form-control mb-3" rows="4" v-model="v.user_comment" placeholder="Комментарий к задаче..."></textarea>
        <img :alt="v.task" :src="getImageByModel(v, `task-photo-${v.id}`)" :id="`task-photo-${v.id}`" :style="`display: ` + (v.photo_1 ? 'block' : 'none')" class="one-photo" />
        <short-time-line :model="v" />
        <div class="d-flex justify-content-between">
          <div>
            <!-- To android/ios platform -->
            <div class="offcanvas offcanvas-bottom" tabindex="-1" :id="`offcanvasPhoto` + v.id" aria-labelledby="offcanvasPhotoLabel">
              <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="offcanvasPhotoLabel">Что хотите сделать?</h5>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" :id="`task--btn-close-photo-selector-${v.id}`"></button>
              </div>
              <div class="offcanvas-body pt-0">
                <button type="button" @click="takePhoto(v)" class="btn btn-primary w-100 mb-3 rounded-pill">Открыть камеру</button>
                <button type="button" @click="selectPhoto(v)" class="btn btn-primary w-100 mb-3 rounded-pill">Выбрать из галереи</button>
              </div>
            </div>
            <!-- /To android/ios platform -->
            <!-- To web platform -->
            <div class="d-none">
              <input type="file" @change="attachFile($event, v, this)" :id="`task--append-file-${v.id}`" accept="capture=camera,image/*" />
            </div>
            <!-- /To web platform -->
          </div>
          <button v-if="['android', 'ios'].includes(PLATFORM)" type="button" class="btn flex-fill btn-secondary w-50 me-3" data-bs-toggle="offcanvas" :data-bs-target="`#offcanvasPhoto` + v.id" aria-controls="offcanvasPhoto">
            <i class="bi bi-camera-fill me-2"></i>Фото
          </button>
          <button v-else type="button" @click="attachFileDialog(v)" class="btn flex-fill btn-secondary w-50 me-3">
            <span v-if="hasAttachedFile(v)" class="text-success">Прикреплено</span>
            <span v-else><i class="bi bi-camera-fill me-2"></i>Фото</span>
          </button>
          <button type="submit" class="btn flex-fill btn-primary w-50">Сохранить</button>
        </div>
      </div>
    </div>
    </transition>
  </form>
</template>

<script>
import { selectPhoto, takePhoto } from "@/helpers/camera";
import ShortTimeLine from "@/components/ShortTimeLine";
import getImageByModel from "@/mixins/getImageByModel";
import nodeList from "@/mixins/nodeList";
import EnvConfig from "@/env";

export default {
  data() {
    return {
      PLATFORM: EnvConfig.PLATFORM,
    }
  },
  props: [
    "selectedTasks",
    "v",
  ],
  components: {
    ShortTimeLine
  },
  mixins: [
    getImageByModel,
    nodeList,
  ],
  methods: {
    takePhoto(model) {
      takePhoto(base64image => {
        const img = document.getElementById(`task-photo-${model.id}`);
        img.src = model.photo_1 = `${base64image}`;
        img.style.display = 'block';
      });
      this.closeSelectPhotoPopup(model);
    },
    selectPhoto(model) {
      selectPhoto(base64image => {
        const img = document.getElementById(`task-photo-${model.id}`);
        img.src = model.photo_1 = `${base64image}`;
        img.style.display = 'block';
      });
      this.closeSelectPhotoPopup(model);
    },
    closeSelectPhotoPopup(model) {
      document.getElementById(`task--btn-close-photo-selector-` + model.id).click();
    },
    attachFileDialog(model) {
      const inputFile = document.getElementById(`task--append-file-${model.id}`);
      inputFile.click();
    },
    hasAttachedFile(model) {
      const inputFile = document.getElementById(`task--append-file-${model.id}`);
      return inputFile?.files?.length;
    },
    async attachFile(event, model) {
      const getBase64 = file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      };
      const file = event.target.files.length ? event.target.files[0] : null;

      if (!file) {
        return;
      }
      try {
        model.photo_1 = await getBase64(file);
      } catch (e) {
        console.error('Error uploading file', e);
      }
    },
    select(m) {
      this.selectedTasks.push(+m.id);
    },
    deselect(m) {
      this.$emit(
        'selectedTasksUpdater',
        this.selectedTasks.filter(id => id !== +m.id)
      );
    },
    isSelected(m) {
      // return true;
      return this.selectedTasks.includes(+m.id);
    },
    save(m) {
      this.deselect(m);
      m.is_done = m._is_done;
      m.flush();
    },
  }
}
</script>